import { render, staticRenderFns } from "./CollapseBlock.vue?vue&type=template&id=9d6989ec&"
import script from "./CollapseBlock.vue?vue&type=script&lang=js&"
export * from "./CollapseBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports